import { Routes } from '@angular/router';
import { authGuard } from '../../_shared/helpers';
import { WarehouseComponent } from './warehouse/warehouse.component';

export const WAREHOUSE_ROUTES: Routes = [
  {
    path: 'warehouse/overview',
    component: WarehouseComponent,
    canActivate: [authGuard],
  },
];
